<template>
  <!-- Approved Pass View - Shown when the pass is in approved/active status -->
  <div
    class="bg-white rounded-30 d-flex flex-column justify-content-between align-items-center m-3"
  >
    <!-- Comments section -->
    <PassCommentsList :comments="comments" />

    <!-- Timer component for approved passes with control buttons -->
    <PassTimer
      :active-pass="activePass"
      :time-in-pass="timeInPass"
      :current-status="currentStatus"
      :is-pass-long-running="isPassLongRunning"
      :pin-attempts-count="pinAttemptsCount"
      :is-active-auto-check-in-module="isActiveAutoCheckInModule"
      @auto-pause="$emit('auto-pause')"
      @show-check-in="$emit('show-check-in')"
    />
  </div>
</template>

<script>
import PassCommentsList from "./PassCommentsList.vue"
import PassTimer from "./PassTimer.vue"

export default {
  name: "ApprovedPassView",
  components: {
    PassCommentsList,
    PassTimer
  }
}
</script>

<script setup>
defineProps({
  activePass: {
    type: Object,
    default: () => ({})
  },
  comments: {
    type: Array,
    default: () => []
  },
  timeInPass: {
    type: String,
    default: ""
  },
  currentStatus: {
    type: String,
    default: ""
  },
  isPassLongRunning: {
    type: Boolean,
    default: false
  },
  pinAttemptsCount: {
    type: Number,
    default: 0
  },
  isActiveAutoCheckInModule: {
    type: Boolean,
    default: false
  }
})

defineEmits(["auto-pause", "show-check-in"])
</script>
